@let target = targetWord();
@if (target) {
  <lib-keyboard-activity
    (onCompleteWord)="completeWord()"
    (onWrongInput)="onWrongInput()"
    [assignment]="assignment()"
    [targetWord]="target"
  >
    <div class="text-4xl text-white drop-shadow" target>
      {{ target.word }}
    </div>
  </lib-keyboard-activity>
} @else {
  <p>Loading target word..</p>
}
